import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone/moment-timezone';

import styles from './TZ.module.scss';
import { actionsTZ } from './redux/actions';
import { openModalAction } from '../../actions/modal';
import TimezoneChangeModal from '../../modals/TimezoneChangeModal/TimezoneChangeModal';
import { DEFAULT_TIMEZONE } from '../../constants';
import Strings from '../../Strings';
import { TZ_UPDATE_USER_TIMEZONE_RESULT } from './redux/const';
import { notificationActions } from '../../components/Notification/redux/actions';

function TZ(props) {
  const [timezoneText, setTimezoneText] = useState(null);

  useEffect(() => {
    if (props.username && props.timezone) {
      // Use moment-timezone to get the abbreviation dynamically (handles DST).
      // Some zones (e.g. Atlantic/Cape_Verde) return a raw numeric offset like "-01"; format as "GMT-1".
      const abbrev = moment.tz(props.timezone).format('z');
      const isNumericOffset = /^[+-]\d+$/.test(abbrev);
      setTimezoneText(isNumericOffset ? `GMT${parseInt(abbrev, 10) >= 0 ? '+' : ''}${parseInt(abbrev, 10)}` : abbrev);
      moment.tz.setDefault(props.timezone);
    } else if (props.username && !props.timezone) {
      // No timezone set, use default
      props.updateUserTimezone(DEFAULT_TIMEZONE).then(resp => {
        if (resp.type === TZ_UPDATE_USER_TIMEZONE_RESULT) {
          window.location.reload();
        } else {
          props.showNotification('Error while updating timezone settings', 5000);
        }
      });
    }
  }, [props.timezone, props.username]);

  return timezoneText ? (
    <React.Fragment>
      <label htmlFor="timezoneId" className="visuallyhidden">
        {Strings.selectedTimezone} {timezoneText} {Strings.timepickerAL}
      </label>
      <div
        className={styles.container}
        onClick={props.openTimezoneModal}
        onKeyDown={e => {
          const charCode = e.which ? e.which : e.keyCode;
          if (charCode === 13) {
            this.onClick();
          }
        }}
        tabIndex={0}
        role="button"
        id="timezoneId"
      >
        <div className={styles.text}>{timezoneText}</div>
      </div>
    </React.Fragment>
  ) : (
    <React.Fragment />
  );
}

TZ.propTypes = {
  openTimezoneModal: PropTypes.func,
  timezone: PropTypes.string,
  updateUserTimezone: PropTypes.func,
  showNotification: PropTypes.func,
  username: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    timezone: state.auth?.profile?.preferences?.timezone,
    username: state.auth?.profile?.username,
  };
};

const mapDispatchToProps = dispatch => ({
  openTimezoneModal: () => dispatch(openModalAction(TimezoneChangeModal.MODAL_NAME)),
  updateUserTimezone: timezone => dispatch(actionsTZ.updateUserTimezone(timezone)),
  showNotification: (message, timeout) => dispatch(notificationActions.show(message, timeout)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TZ);
